import {
  ActivitySettings,
  ActivityType,
  DiagramGeneralSettings,
  FlowlineSettings,
  PositionType
} from '../diagram-type-styles.model';
import {ArchitectureBaseConfig} from './diagram-architecture-base-config';
import {FlowlineForm} from '../flowline-form.enum';
import {IAttributeJson} from '../../../diagram-data/diagram-json-handler.service';
import {MAPS_TYPES_ENUM as MAP_TYPES} from '../../../editor-interface/shared/models/map.model';

export class DataModelConfig extends ArchitectureBaseConfig {
  generalSettings(): DiagramGeneralSettings {
    return {
      ...super.generalSettings(),
      tagName: 'Data Model',
      tagColor: '#465a72',
      allowedDrilldownSubtypes: [
        MAP_TYPES.DATA_MODEL,
        MAP_TYPES.INTERACTION_FLOW,
        MAP_TYPES.SYSTEM_ARCHITECTURE
      ]
    };
  }

  readonly activityShape = {w: 200, h: 210};
  readonly activityText = 'Data Entity';
  readonly activityTypes: ActivityType[] = [
    {
      tooltip: 'ASIDE_L.DATAMODEL_DEFAULT_ACTIVITY_TOOLTIP',
      icon: 'activity_icon_v4',
      settings: (x?: number, y?: number) => this.activitySettings(x, y)
    },
    {
      tooltip: 'ASIDE_L.DATAMODEL_EMPTY_ACTIVITY_TOOLTIP',
      icon: 'activity_icon_v3',
      settings: (x?: number, y?: number) => this.activitySettingsWithoutInfo(x, y)
    }
  ];

  activitySettingsWithoutInfo(x?: number, y?: number): ActivitySettings {
    const emptyActivityShape = {w: 200, h: 100};

    return {
      ...super.activitySettings(x, y),
      text: this.activityText,
      defaultActivityShape: emptyActivityShape,
      position: this.getPosition(emptyActivityShape, x, y, PositionType.CENTER),
      dragHandlePosition: this.getPosition(emptyActivityShape, x, y, PositionType.DEFAULT)
    };
  }

  activitySettings(x?: number, y?: number): ActivitySettings {
    const defaultAttributes: IAttributeJson[] = [
      {mxKey: 1, text: 'Attribute 1'},
      {mxKey: 2, text: 'Attribute 2'},
      {mxKey: 3, text: 'Attribute 3'}
    ];

    return {
      ...super.activitySettings(x, y),
      text: this.activityText,
      footerText: 'Provide short description...',
      defaultAttributes
    };
  }

  flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings {
    return {
      ...super.flowlineSettings(x, y, id),
      form: {
        shape: FlowlineForm.shape.Orthogonal,
        type: FlowlineForm.type.Solid,
        start: FlowlineForm.end.ZeroToOne,
        end: FlowlineForm.end.ZeroToMany
      }
    };
  }
}
